import { render } from "./index.vue?vue&type=template&id=527bb6da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=527bb6da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-527bb6da"

export default script